export enum TableType {
    Ring = 1, // endless table where anyone can sit and leave when they want.
    SnG = 2, // tournament that start when the number of pre-configured players is reached.
    Tournament = 4, // fixed date/hour to win the game, multiple tables collapse together as player get eliminated.
    PlayNow = 8, // the player join a "table template" and server assigned to a random table and seat. If there is many tables of the same "template" the player can join multiple times.
    SpinnGo = 16 // Sit n Go with 3 players where pool prize is random.
}
